/* src/app/pages/tasks/components/reminders/task-reminder/task-reminder.component.scss */
.container__entity,
.container__actions,
.container__header,
.container__content-header {
  display: flex;
  flex-direction: row;
}
.container__content,
.container {
  display: flex;
  flex-direction: column;
}
.container__link,
.container__icon--clickable {
  cursor: pointer;
  transition: opacity 0.12s linear;
  color: #607bee;
}
.container__link:hover,
.container__icon--clickable:hover,
.container__link:focus,
.container__icon--clickable:focus {
  opacity: 0.7;
  outline: none;
}
.container__content-details--completed,
.container__task-name--completed,
.container__content-title--completed {
  color: #a4a4a4;
}
.container {
  margin-bottom: 20px;
}
.container__header,
.container__content-header {
  justify-content: space-between;
  margin-bottom: 5px;
  gap: 8px;
}
.container__title {
  color: #3d3c40;
  font-weight: 300;
}
.container__actions {
  gap: 4px;
}
.container__icon {
  width: 16px;
  height: 16px;
}
.container__icon--completed {
  color: #a4a4a4;
}
.container__content {
  background-color: #f1f3ff;
  padding: 20px;
  border-radius: 8px;
}
.container__content--completed {
  background-color: #f2f2f2;
}
.container__content-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}
.container__entity {
  gap: 4px;
  margin-inline-start: 4px;
  align-items: center;
}
.container__link {
  margin-inline-start: 10px;
  font-size: 14px;
  color: #2a56c9;
  text-decoration: none;
}
.container__link--single {
  margin-inline-start: 0;
}
.container__link--disabled,
.container__link--completed {
  color: #a4a4a4;
}
.container__content-details {
  background-color: #e3e7ff;
  min-height: 4.5em;
  line-height: 1.5;
  padding: 8px;
  border-radius: 8px;
  border: none !important;
}
.container__content-details--completed {
  background-color: #ebebec;
}
/*# sourceMappingURL=task-reminder.component.css.map */
